import {airBlue} from '@modifi/colors'
import {Link} from '@modifi/router'
import {Caption} from '@modifi/ui'
import styled from 'styled-components'

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${airBlue};
`

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const DateFilterWrapper = styled.div`
  .SingleDatePicker_picker {
    left: -240px !important;
  }
`
export const StyledCaption = styled(Caption)<{isStriked?: boolean}>`
  ${({isStriked}): string => (isStriked ? 'text-decoration: line-through;' : '')}
`
